export default {"src":"/_next/static/media/rank1.110438af.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};